const cookie_accept =  document.querySelector("#pdcc-modal-accept")

if(cookie_accept) {
	cookie_accept.addEventListener("click", function() {
  let setItem = sessionStorage.setItem("true", true)
});
}

function getCookie(name) {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(';').shift();
}
const tt = JSON.parse(getCookie('pd_cc')) || false;
if(tt) {
  if(tt.accepted) {
  	console.log(tt,"xoski")
  }
	
}